export default __webpack_public_path__ + "static/media/nabati-logo.d875faa5.png";